/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { classnames as cx, propsUtils } from '@ba-ui-toolkit/utils';
import Container from '@ba-ui-toolkit/container';
import Label from '@ba-ui-toolkit/label';
// TODO build out clickRelay component?
// import ClickRelay from '../controls/ClickRelay';
import SVGIcon from '@ba-ui-toolkit/svgicon';

import styles from './PropertiesPane.scss';

const propertiesPaneClassName = styles.propertiesPaneClassName.replace(/"/g, '');
const { sanitize, BaPropTypes } = propsUtils;

export default class PropertiesPane extends Component {
	static propTypes = {
		icon: BaPropTypes.deprecated(
			'It will be removed soon, use "validationRenderer", "descriptionRenderer", "changeRenderer" instead'
		),
		validationNode: PropTypes.node,
		descriptionNode: PropTypes.node,
		changeIndicatorNode: PropTypes.node,
		label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
		htmlFor: PropTypes.string,
		className: PropTypes.string,
		labelId: PropTypes.string,
		style: PropTypes.object,
		labelStyle: PropTypes.object,
		labelSize: PropTypes.oneOf(['small', 'medium', 'large', 'full']),
		disabled: PropTypes.bool,
		rtl: PropTypes.bool,
		dataLabel: PropTypes.bool,
		children: PropTypes.node,
	};

	static defaultProps = {
		labelSize: 'medium',
		className: '',
		style: {},
		labelStyle: {},
	};

	_onClick(labelAction) {
		return e => {
			labelAction && e.preventDefault();
		};
	}

	_isLabelAction() {
		const { children } = this.props;
		let labelAction;
		let child;
		try {
			child = React.Children.only(children).type;
			// prevent dropdown focusing on label click
			labelAction = child.__Select__ || child.__ComboBox__ || child.__SelectGroup__ || false;
		} catch (err) {
			labelAction = false;
		}

		return labelAction;
	}

	render() {
		const {
			icon,
			label,
			htmlFor,
			labelId,
			disabled,
			rtl,
			dataLabel,
			children,
			className,
			style,
			labelStyle,
			labelSize,
			validationNode,
			descriptionNode,
			changeIndicatorNode,
			...others
		} = this.props;
		const isColumn = labelSize === 'full';

		const labelAction = this._isLabelAction();

		let iconComponent;
		const iconType = typeof icon;
		if (iconType !== 'undefined') {
			// will be deprecated
			iconComponent = (
				<span className={`${propertiesPaneClassName}__iconPosition`}>
					{iconType === 'string' ? (
						<SVGIcon
							className={cx(`${propertiesPaneClassName}__icon`)}
							disabled={disabled}
							iconId={icon}
							size="small"
						/>
					) : (
						icon
					)}
				</span>
			);
		}
		let labelContent = (
			<div className={`${propertiesPaneClassName}__labelContent ${cx({ rtl })}`}>
				{iconComponent}
				{typeof label === 'string' ? (
					<Label
						onClick={this._onClick(labelAction)}
						htmlFor={htmlFor}
						label={label}
						disabled={disabled}
						ellipsis={dataLabel}
						style={labelStyle}
					/>
				) : (
					label
				)}
			</div>
		);

		if (validationNode || descriptionNode || changeIndicatorNode) {
			labelContent = (
				<div className={`${propertiesPaneClassName}__labelContent ${cx({ rtl })}`}>
					{validationNode}
					{descriptionNode}
					{typeof label === 'string' ? (
						<Label
							onClick={this._onClick(labelAction)}
							htmlFor={htmlFor}
							label={label}
							disabled={disabled}
							ellipsis={dataLabel}
							style={labelStyle}
						/>
					) : (
						label
					)}
					{changeIndicatorNode}
				</div>
			);
		}

		const classNames = cx(propertiesPaneClassName, { rtl });

		return (
			<Container
				{...sanitize(others, PropertiesPane)}
				padding={[0, 0]}
				className={`${classNames} ${className}`}
				style={style}
			>
				<Container
					className={cx(
						`${propertiesPaneClassName}__inner`,
						labelSize,
						isColumn ? 'column' : ''
					)}
				>
					<Container className={cx(`${propertiesPaneClassName}__label`)} id={labelId}>
						{labelContent}
					</Container>
					<Container className={cx(`${propertiesPaneClassName}__children`)}>
						{children}
					</Container>
				</Container>
			</Container>
		);
	}
}
